import Vue from "vue";
let currentRequest = 0;

const AttachmentService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("attachment", id, {
        include: "file_type"
      });
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START ATTACHMENT `, searchFilterPagination.search);
      searchFilterPagination.include = "file_type,taggings";
      const res = await Vue.$jsonApi.findAll(
        "attachments",
        searchFilterPagination
      );
      if (request !== currentRequest) {
        console.log(`[${request}] ATTACHMENT DISCARDED`);
        return null;
      }
      console.log(`[${request}] END ATTACHMENT `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("attachment", payload);
      } else {
        return await Vue.$jsonApi.update("attachment", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("attachments", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { AttachmentService };
